import script from "./SubHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./SubHeader.vue?vue&type=script&setup=true&lang=js"

import "./SubHeader.vue?vue&type=style&index=0&id=4fde6b60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fde6b60"]])

export default __exports__